<template>
  <div class="whatWeOffer">
    <Accordion />
  </div>
</template>


<script>
import Accordion from "@/components/accordion";
export default {
  components: {
    Accordion
  }
};
</script>